import mitt from 'mitt'
import {inject} from "vue";

export default {
    install(app) {
        const emitter = mitt();
        app.provide('emitter', emitter);
        app.config.globalProperties.$emitter = emitter;
    }
}

export function useEmitter() {
    return inject('emitter');
}